module.exports = __webpack_public_path__ + "img/user-04.ac29a257.jpg";